<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6" style="border-top: solid #f1c40f 4px;">
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <mat-icon class="w-6 h-6">assessment</mat-icon>
        <h2 class="text-2xl font-bold mb-0">Berichte</h2>
      </div>

      <div class="flex space-x-2">
        <button (click)="loadReports()" mat-raised-button color="primary">
          <mat-icon class="w-5 h-5">refresh</mat-icon>
          Aktualisieren
        </button>
      </div>
    </div>

    <!-- Search and Filter Section -->
    <div class="mt-6 mb-6">
      <div class="flex flex-row gap-4 items-center">
        <!-- Search Box -->
        <div class="flex-none">
          <div class="relative">
            <input
              type="text"
              class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 min-w-[160px]"
              placeholder="Suche Berichte..." 
              [(ngModel)]="searchTerm"
              (keyup)="onSearch()"
            />
            <button
              *ngIf="searchTerm"
              type="button"
              class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              (click)="searchTerm = ''; onSearch()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
                <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Kunde Autocomplete Filter -->
        <div class="flex-none">
          <div class="relative">
            <input
              type="text"
              class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 min-w-[140px]"
              placeholder="Kunde suchen..."
              [(ngModel)]="kundeSearchValue"
              (input)="onKundeSearch($event)"
              (focus)="onKundeFocus()"
              (blur)="onKundeBlur()"
            />
            
            <!-- Clear button for Kunde -->
            <button
              *ngIf="selectedKunde"
              type="button"
              class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              (click)="clearKundeFilter()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
                <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
              </svg>
            </button>

            <!-- Kunde Autocomplete Dropdown -->
            <div
              *ngIf="showKundeAutocomplete && filteredKunden.length > 0"
              class="absolute left-0 z-50 mt-2 w-80 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-white/10 max-h-60 overflow-y-auto"
              (click)="$event.stopPropagation()">
              <div class="py-1" role="none">
                <button
                  *ngFor="let kunde of filteredKunden"
                  type="button"
                  class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                  role="menuitem"
                  tabindex="-1"
                  (click)="selectKunde(kunde)">
                  <div class="font-medium">{{ kunde.suchbegriff || kunde.name }}</div>
                  <div class="text-xs text-gray-500" *ngIf="kunde.name && kunde.suchbegriff !== kunde.name">{{ kunde.name }}</div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Standort Autocomplete Filter -->
        <div class="flex-none">
          <div class="relative">
            <input
              type="text"
              class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 min-w-[120px]"
              placeholder="Standort suchen..."
              [(ngModel)]="standortSearchValue"
              (input)="onStandortSearch($event)"
              (focus)="onStandortFocus()"
              (blur)="onStandortBlur()"
            />
            
            <!-- Clear button for Standort -->
            <button
              *ngIf="selectedStandort"
              type="button"
              class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              (click)="clearStandortFilter()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
                <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
              </svg>
            </button>

            <!-- Standort Autocomplete Dropdown -->
            <div
              *ngIf="showStandortAutocomplete && filteredStandorte.length > 0"
              class="absolute left-0 z-50 mt-2 w-80 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-white/10 max-h-60 overflow-y-auto"
              (click)="$event.stopPropagation()">
              <div class="py-1" role="none">
                <button
                  *ngFor="let standort of filteredStandorte"
                  type="button"
                  class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                  role="menuitem"
                  tabindex="-1"
                  (click)="selectStandort(standort)">
                  <div class="font-medium">{{ standort.name }}</div>
                  <div class="text-xs text-gray-500" *ngIf="standort.nummer">Nr. {{ standort.nummer }}</div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Date From -->
        <div class="flex-none">
          <input
            type="date"
            class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 min-w-[140px]"
            [(ngModel)]="filters.date_from"
            (change)="onFilterChange()"
          />
        </div>

        <!-- Date To -->
        <div class="flex-none">
          <input
            type="date"
            class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 min-w-[140px]"
            [(ngModel)]="filters.date_to"
            (change)="onFilterChange()"
          />
        </div>

        <!-- Clear All Filters Button -->
        <div class="flex items-end">
          <button 
            mat-stroked-button 
            (click)="clearFilters()"
            class="h-10">
            <mat-icon class="mr-2 w-5 h-5">clear_all</mat-icon>
            Clear
          </button>
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="loading" class="flex justify-center items-center py-8">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>

    <!-- Error Message -->
    <div *ngIf="!loading && dataSource.data.length === 0" class="text-center py-8">
      <mat-icon class="text-gray-400 w-24 h-24 mb-4">assessment</mat-icon>
      <p class="text-gray-500 text-lg">Keine Berichte gefunden</p>
    </div>

    <!-- Reports Table -->
    <div class="mt-8 flow-root" *ngIf="!loading && dataSource.data.length > 0">
      <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <table class="relative min-w-full divide-y divide-gray-300 dark:divide-white/15">
            <thead>
              <tr>
                <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">Einsatz</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Kunde / Standort</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Bericht</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Techniker</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Erstellt</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Status</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Version</th>
                <th scope="col" class="whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                  <span class="sr-only">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900">
              <tr 
                *ngFor="let report of dataSource.data; let i = index" 
                class="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
                [ngClass]="{'bg-gray-50 dark:bg-gray-800': i % 2 === 1}">
                <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 dark:text-white">
                  {{ report.einsatznummer }}
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm sm:pl-0">
                  <div class="font-medium text-gray-900 dark:text-white">{{ getClientName(report) }}</div>
                  <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ report.standort_name }}</div>
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  {{ getReportCategoryLabel(report.report_category) }}
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  {{ report.techniker_name }}
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm sm:pl-0">
                  <div class="text-gray-500 dark:text-gray-400">{{ formatDateOnly(report.created_at) }}</div>
                  <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ formatTimeOnly(report.created_at) }}</div>
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
                        [ngClass]="getStatusClass(report.status)">
                    {{ getStatusText(report.status) }}
                  </span>
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  v{{ report.version }}
                </td>
                <td class="whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                  <div class="relative inline-flex rounded-md shadow-sm">
                    <button
                      type="button"
                      class="inline-flex items-center rounded-l-md bg-white px-2 py-1.5 text-xs font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20"
                      (click)="downloadReport(report); $event.stopPropagation()"
                      title="PDF herunterladen">
                      Download
                    </button>
                    <button
                      type="button"
                      class="inline-flex items-center rounded-r-md bg-white px-1.5 py-1.5 text-xs font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 -ml-px"
                      (click)="toggleActionDropdown(report.id, $event)"
                      title="Weitere Aktionen">
                      <svg class="h-3 w-3" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
                      </svg>
                    </button>
                    <div
                      *ngIf="openDropdownId === report.id"
                      class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-white/10"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="menu-button"
                      tabindex="-1">
                      <div class="py-1" role="none">
                        <button
                          type="button"
                          class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                          role="menuitem"
                          tabindex="-1"
                          (click)="downloadReport(report); $event.stopPropagation(); openDropdownId = null">
                          Download
                        </button>
                        <button
                          type="button"
                          class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                          role="menuitem"
                          tabindex="-1"
                          (click)="viewReport(report); $event.stopPropagation(); openDropdownId = null">
                          Ansehen
                        </button>
                        <button
                          type="button"
                          class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                          role="menuitem"
                          tabindex="-1"
                          (click)="viewKontrolltermin(report); $event.stopPropagation(); openDropdownId = null">
                          zum Kontrolltermin
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Paginator -->
    <mat-paginator
      *ngIf="!loading && dataSource.data.length > 0"
      [length]="totalItems"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPageChange($event)"
      showFirstLastButtons
      aria-label="Select page of reports">
    </mat-paginator>
  </div>
</div>
